import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CheckBoxSharedComponent } from './checkbox.component';

@NgModule({
    declarations: [
        CheckBoxSharedComponent
    ],
    imports: [
        CommonModule
    ],
    exports: [
        CheckBoxSharedComponent
    ]
})

export class CheckBoxSharedModule {}
